import { styled } from '@uhg-abyss/web/tools/styled';
import { Flex } from '@uhg-abyss/web/ui/Flex';

export const PageContainer = styled('div', {
  padding: '0px',
  backgroundColor: '$mapViewContainerBgColor',
  borderTop: '1px solid rgb(229, 229, 230)',
  '@media (max-width: 464px)': { borderTop: 'none' },
});

export const AlertBannerWrapper = styled('div', {
  maxWidth: '1200px',
  margin: '0 auto',
  padding: '0 0 1px',
  '@media (max-width: 1248px)': {
    margin: '0 0 0 24px',
    maxWidth: 'none',
  },
  marginBottom: '20px !important',
});

export const MapViewWrapper = styled('div', {
  maxWidth: '1440px',
  marginLeft: 'calc((100vw - 1216px)/2) ',
  marginRight: '24px',
  padding: '16px 0',
  '@media (max-width: 1248px)': {
    marginLeft: '24px',
    marginRight: '24px',
  },
  '@media (max-width: 744px)': {
    marginLeft: '16px',
    marginRight: '16px',
    padding: '16px 0',
  },
  '@media (max-width: 464px)': {
    padding: '0',
    margin: '0',
  },
});

export const MapViewWrapperFullWidth = styled('div', {
  dynamic: ({
    cssProps: {
      expandedProviderListView,
      enableMapViewHideOption,
      navigateToDirections,
      isOpenCompareShare,
      enableMapViewEnhancements,
    } = {},
  }) => ({
    maxWidth: '100%', // '80.89%',
    // marginLeft: '96px',
    // padding: '24px 0',
    '@media (min-width: 1249px)': {
      marginLeft: '48px',
      marginRight: '48px',
    },
    '@media (max-width: 1248px)': {
      marginLeft: '24px',
      marginRight: '24px',
    },
    marginLeft: enableMapViewHideOption
      ? expandedProviderListView
        ? navigateToDirections
          ? '16px'
          : '0 !important'
        : ''
      : '',
    marginRight: enableMapViewHideOption
      ? expandedProviderListView
        ? navigateToDirections
          ? '16px'
          : '0 !important'
        : '0 !important'
      : '0 !important',
    padding: enableMapViewEnhancements
      ? isOpenCompareShare
        ? '0 0 24px 0'
        : '0'
      : '24px 0',
    '@media (max-width: 744px)': {
      padding: enableMapViewEnhancements ? '0px' : '16px 0',
      marginLeft: enableMapViewEnhancements && '0',
    },
  }),
});

export const EnhancePaginationMobileStyles = {
  '.abyss-psx-parcel-c-PJLV-ihNPJpp-css': {
    '&:last-of-type': {
      position: 'sticky',
      bottom: '0',
      zIndex: '99',
      backgroundColor: 'white',
      ['@media (max-width: 975px) and (orientation: landscape)']: {
        position: 'static',
      },
    },
  },
};

export const HeaderContainer = styled('div', {
  dynamic: ({
    cssProps: {
      urlCheck,
      enableMapViewEnhancements,
      enableMapFilterSortCTA,
    } = {},
  }) => ({
    position:
      enableMapViewEnhancements && (enableMapFilterSortCTA ? '' : 'sticky'),
    top:
      enableMapViewEnhancements &&
      (urlCheck ? (enableMapFilterSortCTA ? '0px' : '40px') : '0px'),
    zIndex: enableMapViewEnhancements && (enableMapFilterSortCTA ? '' : '999'),
  }),
});

export const FilterMapFullWidth = styled('div', {
  dynamic: ({
    cssProps: { urlCheck, stickyHeaderDisabled, isLAWWGuestExperience } = {},
  }) => ({
    maxWidth: '100%', // '80.89%',
    paddingLeft: '96px',
    paddingTop: '8px',
    borderBottom: '1px solid rgb(229, 229, 230)',
    position: stickyHeaderDisabled ? 'static' : 'sticky',
    top: urlCheck || isLAWWGuestExperience ? '40px' : '0',
    zIndex: '4',
    backgroundColor: 'white',

    paddingBottom: '0px',

    '@media (min-width: 1249px)': {
      paddingLeft: '48px',
    },
    '@media (max-width: 1248px)': {
      paddingLeft: '24px',
    },
  }),
});

export const MobileFilterContainer = styled(Flex, {
  dynamic: ({
    cssProps: { urlCheck, enableMapFilterSortCTA, stickyHeaderDisabled } = {},
  }) => ({
    padding: enableMapFilterSortCTA && '16px 0 12px 0',
    position: stickyHeaderDisabled
      ? 'static'
      : enableMapFilterSortCTA && 'sticky',
    top: enableMapFilterSortCTA && urlCheck ? '40px' : '0',
    zIndex: stickyHeaderDisabled ? '100' : enableMapFilterSortCTA && '999',
    backgroundColor: enableMapFilterSortCTA && 'white',
    ['@media (max-width: 975px) and (orientation: landscape)']: {
      position: 'static',
    },
  }),
});

export const MobileResultContainer = styled(Flex, {
  dynamic: ({
    cssProps: {
      choosePCP,
      urlCheck,
      enableMapFilterSortCTA,
      stickyHeaderDisabled,
      compareShareToggle,
    } = {},
  }) => ({
    display: 'grid',
    margin: '0 0 6px 0 ',
    padding: '16px 0 0 24px',
    position: stickyHeaderDisabled ? 'static' : 'sticky',
    top: compareShareToggle
      ? '0px'
      : enableMapFilterSortCTA
      ? urlCheck
        ? '126px'
        : '86px'
      : choosePCP
      ? urlCheck
        ? '224px'
        : '184px'
      : urlCheck
      ? '152px'
      : '112px',
    zIndex: '2',
    backgroundColor: 'white',
    '@media (max-width: 743px) and (orientation: landscape)': {
      position: 'static',
    },
  }),
});
